<template>
  <tr
    class="tw-cursor-pointer"
    :data-testid="`document-entry-${entry.title}-${
      selected ? 'selected' : 'unselected'
    }`"
    @click="emit('toggleSelection', entry)"
  >
    <td
      :class="highlightClass"
      class="
        !tw-border-l-0
        !tw-border-r-0
        !tw-border-b-0
        !tw-border-sf-neutral-lighter-2
        tw-w-8 tw-text-center
      "
    >
      <input
        class="!-tw-mt-1"
        type="checkbox"
        :checked="selected"
        data-testid="export-row-checkbox"
        @click.stop="emit('toggleSelection', entry)"
      />
    </td>
    <td
      ref="titleRef"
      v-tooltip="titleTooltip"
      :class="highlightClass"
      class="
        tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap
        !tw-border-l-0
        !tw-border-r-0
        !tw-border-b-0
        !tw-border-sf-neutral-lighter-2
      "
    >
      {{ entry.title }}
    </td>
    <td
      class="
        !tw-border-l-0
        !tw-border-r-0
        !tw-border-b-0
        !tw-border-sf-neutral-lighter-2
      "
      :class="highlightClass"
    >
      {{ entry.exportedBy }}
    </td>
    <td
      class="
        !tw-border-l-0
        !tw-border-r-0
        !tw-border-b-0
        !tw-border-sf-neutral-lighter-2
      "
      :class="highlightClass"
    >
      {{ date }}
    </td>
    <td
      :class="highlightClass"
      class="
        sf-table-button-cell
        !tw-border-l-0
        !tw-border-r-0
        !tw-border-b-0
        !tw-border-sf-neutral-lighter-2
      "
    >
      <SfButtonDs
        variant="tertiary"
        size="sm"
        icon-only
        icon-before="eye"
        :aria-label="
          I18n.t('components.document.existing_docs_modal.view_export')
        "
        @click.stop="openUrl"
      />
    </td>
  </tr>
</template>

<script setup lang="ts">
import communicationDate from '@app/utils/communication-date'
import { computed, ref } from 'vue'
import useDynamicTooltip from '@app/shared/vue/composables/use-dynamic-tooltip'
import type { ExportType } from '@app/application/export/types'
import { SfButtonDs } from '@silverfin/ui-components'
import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  selected: boolean
  entry: ExportType
}

const props = defineProps<Props>()

const I18n = useI18n()

const emit = defineEmits<{ toggleSelection: [ExportType] }>()

const titleRef = ref<HTMLElement | null>(null)
const titleTooltip = useDynamicTooltip(titleRef, props.entry.title)

const highlightClass = computed(() =>
  props.selected ? 'sf-bg-primary-subtle' : ''
)

const date = computed(() => communicationDate(props.entry.createdAt))

function openUrl() {
  window.open(props.entry.url)
}
</script>

<style scoped lang="scss">
// .sf-table-bordered has styles that can't be overridden with tailwind
td.sf-table-button-cell {
  padding: 2px 6px;
}
</style>
